<template>
  <b-container v-if="itemList.length > 0">
    <b-row>
      <prismic-rich-text
        v-if="title"
        :field="title"
        class="prismic-title-list text-center align-items-center justify-content-center w-100"
      ></prismic-rich-text>

      <b-col v-for="(item, index) in itemList" :key="'item-' + index">
        <div class="text-center align-items-center justify-content-center">
          <a v-if="item.blank" :href="item.path" target="_blank">
            <Item :image="item.image.url" :alt="item.image.alt" :title="item.title" />
          </a>
          <nuxt-link v-else :to="item.path">
            <Item :image="item.image.url" :alt="item.image.alt" :title="item.title" />
          </nuxt-link>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Item from '../components/Item.vue';

export default {
  components: {
    Item
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      itemList: [],
      title: ''
    };
  },
  created() {
    this.title = this.slice.primary.title1;
    const items = this.slice.items;

    items.map((el) => {
      if (el.image?.url) {
        const item = {
          image: el.image,
          title: el.title1,
          path: el.path && el.path[0]?.text,
          blank: el.button_blank
        };

        this.itemList.push(item);
      }
    });
  }
};
</script>

<style lang="scss">
.prismic-title-list p {
  color: #707070;
  display: block;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 20px;
}
</style>
